import { useRequestTranslations } from '@procore/cdn-translations'
import { I18nProvider, useI18nContext } from '@procore/core-react'
import React from 'react'

import en from '../locales/en.json'
import pseudo from '../locales/pseudo.json'

export function TextEditorI18nProvider({
  children,
}: Readonly<React.PropsWithChildren>) {
  const clientI18n = useI18nContext()

  const cdnTranslations = useRequestTranslations(
    {
      locale: clientI18n.locale,
      type: 'file',
      absolute_file_path: (locale) =>
        `core/packages/text-editor/src/locales/${locale}.json`,
    },
    {
      en,
      pseudo,
    },
    {
      oldTranslations: {},
      enableCDN: true,
    }
  )

  return (
    <I18nProvider
      locale={clientI18n.locale}
      translations={cdnTranslations.translations}
    >
      {children}
    </I18nProvider>
  )
}
